import { Box, Skeleton } from '@mui/material'
import { useEffect, useState } from 'react'
import { StockService } from '../services/stock.service'
import { useError } from '../context/error'
import StockLogo from './imgs/stock-logo'

interface TickerIconProps {
  symbol: string
  size?: number
}

export default function TickerIcon({ symbol, size = 24 }: TickerIconProps) {
  const { setError } = useError()
  const [logoUrl, setLogoUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    const stockService = new StockService(setError)
    stockService.getStockLogo(symbol).then(res => {
      if (cancelled) return
      if (res?.url) setLogoUrl(res.url)
      setLoading(false)
    })
    return () => { cancelled = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [symbol])

  return (
    <Box sx={{ width: size, height: size, flexShrink: 0 }}>
      {loading ? (
        <Skeleton variant='rectangular' width={size} height={size} sx={{ borderRadius: 0.5 }} />
      ) : (
        <StockLogo src={logoUrl || ''} alt={symbol} sx={{ width: size, height: size }} />
      )}
    </Box>
  )
}
